import { SearchResultAction, SearchResultActionType } from '@scale/shared/types/chat';
import _ from 'lodash';

export const DEFAULT_SEARCH_ACTION: SearchResultAction = {
  actionType: SearchResultActionType.Placeholder,
  thoughts: '',
  input: '',
  output: '',
  currentUrl: '',
};

export const SearchResultActionsRequireInputOutput = [
  SearchResultActionType.Read,
  SearchResultActionType.ControlF,
];

const validateActionType = (actionType: SearchResultActionType) => {
  if (actionType === SearchResultActionType.Placeholder) {
    return 'Action type cannot be empty';
  }
};

const validateText = (text: string | undefined, label: string) => {
  if (!text) {
    return `${label} cannot be empty`;
  }
};

const validateUrl = (url: string) => {
  try {
    // eslint-disable-next-line no-new
    new URL(url);
  } catch (e) {
    return 'Not a valid URL';
  }
};

export const validateAction = (action: SearchResultAction) => {
  const actionTypeValidationResult = validateActionType(action.actionType);
  const thoughtsValidationResult = validateText(action.thoughts, 'Thoughts');
  let inputValidationResult;
  let outputValidationResult;
  if (SearchResultActionsRequireInputOutput.includes(action.actionType)) {
    inputValidationResult = validateText(action.input, 'Input');
    outputValidationResult = validateText(action.output, 'Output');
  }
  const currentURLValidationResult =
    validateText(action.currentUrl, 'Current URL') || validateUrl(action.currentUrl);
  const isValid = !_.some(
    [
      actionTypeValidationResult,
      thoughtsValidationResult,
      inputValidationResult,
      outputValidationResult,
      currentURLValidationResult,
    ],
    item => !!item,
  );
  return {
    isValid,
    actionTypeValidationResult,
    thoughtsValidationResult,
    inputValidationResult,
    outputValidationResult,
    currentURLValidationResult,
  };
};
